import React from 'react'

const CriminalCasesRow = ({meta}) => (
    <tr>
        <td>{meta.case_title}</td>
        <td>{meta.court_code}</td>
        <td className="ir-search-no-wrap"><a href={"/filings/" + meta.case_uuid} target="_blank">{meta.case_no}</a></td>
        <td>{meta.date_filed}</td>
        <td>{meta.date_closed}</td>
    </tr>
)

export default CriminalCasesRow



// WEBPACK FOOTER //
// ./src/components/search/results/CriminalCasesRow.js